export const asiya = {
    id: "asiya",
    name: { ru: "Асия", kz: "Асия" },
    position: { ru: "Врач-невролог", kz: "Дәрігер-невролог" },
    department: "neurology",
    image: "/team_photoes/Асия.svg",
    experience: {
      ru: "8 лет",
      kz: "8 жыл"
    },
    education: {
      ru: `2019 - Казахский национальный медицинский университет имени С.Д. Асфендиярова, специальность "Общая медицина"
2020 - Интернатура по специальности "Неврология" в Казахском национальном медицинском университете имени С.Д. Асфендиярова
2021 - Курсы повышения квалификации по неврологии в Национальном центре нейрохирургии`,
      kz: `2019 - С.Ж. Асфендияров атындағы Қазақ ұлттық медицина университеті, «Жалпы медицина» мамандығы
2020 - С.Ж. Асфендияров атындағы Қазақ ұлттық медицина университетінде «Неврология» мамандығы бойынша интернатура
2021 - Ұлттық нейрохирургия орталығында неврология бойынша біліктілігін арттыру курстары`
    },
    specialization: {
      ru: `• Диагностика и лечение неврологических заболеваний
• Лечение болевых синдромов
• Реабилитация после инсульта
• Лечение головных болей
• Лечение заболеваний позвоночника`,
      kz: `• Неврологиялық ауруларды диагностикалау және емдеу
• Ауырсыну синдромдарын емдеу
• Инсульттан кейінгі оңалту
• Бас ауруларын емдеу
• Омыртқа ауруларын емдеу`
    },
        work: {
    ru: `• 2019 - 2025 Национальный центр спортивной медицины и реабилитации
• 2025 - по настоящее время ГККП "СПОРТИВНЫЙ МЕДИЦИНСКИЙ ЦЕНТР ГОРОДА АСТАНЫ" `,
    kz: `• 2019-2025 жж. – Ұлттық спорттық медицина және оңалту орталығы
• 2025 жылдан бастап – Астана қаласының «Спорттық медицина орталығы» МКҚК`
  },
certificates: {
    ru: `Курсы повышения квалификации:
• 2022 - "Современные методы диагностики и лечения неврологических заболеваний"
• 2023 - "Реабилитация в неврологии"`,
    kz: `Біліктілігін арттыру курстары:
• 2022 - «Неврологиялық ауруларды диагностикалау мен емдеудің заманауи әдістері»
• 2023 - «Неврологиядағы оңалту»`
  }
  };
